import React, {useEffect, useState} from 'react';
import {useStyles} from './dnacpr_styles';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from '@mui/material';
import InlineFormDNACPRView from './dnacpr_view';
import InlineFormDNACPR from './dnacpr';
import * as _orderBy from 'lodash/orderBy';
import {additionalData, updatePatientAdditionalData} from '../../../../store/reducers/additionalData';
import uuidv4 from 'uuid/v4';
import {addNoteForPatient} from '../../../../store/reducers/notes';
import {DNACPROrderStatus} from './dnacpr_data';
import * as _merge from 'lodash/merge';
import moment from 'moment';
import _ from 'lodash';
import * as _find from 'lodash/find';
import FullScreenForm from '../../inpatientForms/fullScreenForm';
import {getTableScrollbar} from '../../../../util/scrollbar';
import clsx from 'clsx';
import AgyleButton from '../../../../components/ui/buttons/agyleButton';
import Notes from '../../../../util/notes';
import API from '../../../../app/api';
import {setSnackbar} from '../../../../store/reducers/globals';
import {changePatientContextTab} from '../../../../store/reducers/patientContext';
import {PATIENT_CONTEXT_TABS_ID} from '../formsUtil';
import {PATIENT_TAGS} from '../../../../util/patientUtil';

function DNACPRTableView(props) {
    const dispatch = useDispatch();
    const classes = useStyles();
    const {t} = useTranslation();

    // Selectors
    const patientAddData = useSelector(additionalData);
    // const f_DNACPR = useSelector(formActiveDNACPR);

    const [haveActiveDNACPR, setActiveDNACPR] = useState(null);
    const [forms_DNACPR, setForms_DNACPR] = useState([]);
    const [dnaCprFormIdView, setDnaCprFormIdView] = React.useState(null);
    const [dnaCprForm, setDnaCprForm] = React.useState(null);
    const [dnaCprFormView, setDnaCprFormView] = React.useState(true);
    const [dnaCprFormVisible, setDnaCprFormVisible] = React.useState(false);


    useEffect(() => {
        if (patientAddData.other.dncpr) {
            setForms_DNACPR(patientAddData.other.dncpr);
            setActiveDNACPR(_find(patientAddData.other.dncpr, (el) => el.status === DNACPROrderStatus.AVAITING || el.status === DNACPROrderStatus.ACTIVE));
        }
    }, [patientAddData]);

    const extendDNARForm = ({user, form, newValidUntilDate}) => {
        let newList = _.cloneDeep(forms_DNACPR);
        let formToExtend = _.find(newList, ['id', form.id]);

        if (form.status === DNACPROrderStatus.AVAITING) {
            let awaiting = {
                validAddedBy: user.firstName + ' ' + user.familyName,
                validAddedById: user.__id,
                validAddedSetDate: moment(),
                validAddedDate: newValidUntilDate,
            };
            if (!formToExtend.awaiting) formToExtend.awaiting = [];

            formToExtend.awaiting.push(awaiting);

            formToExtend = _merge(formToExtend, {validUntilDate: newValidUntilDate});
            let note = Notes.getExtendDncprNote(formToExtend);

            saveAdditionalData(newList, note);
        }
    };

    const counterSignForm = ({user, form}) => {
        let newList = _.cloneDeep(forms_DNACPR);
        let formToSign = _.find(newList, ['id', form.id]);

        let payload = {
            signedBy: user.firstName + ' ' + user.familyName,
            signedById: user.__id,
            signedDate: moment(),
            status: DNACPROrderStatus.ACTIVE,
        };
        formToSign = _merge(formToSign, payload);
        let note = Notes.getSignedDncprNote(formToSign);

        updateTags(true);
        saveAdditionalData(newList, note);
    };

    const deleteForm = ({user, form, canceledReason}) => {
        let newList = _.cloneDeep(forms_DNACPR);
        let formToDelete = _.find(newList, ['id', form.id]);

        let payload = {
            canceledBy: user.firstName + ' ' + user.familyName,
            canceledById: user.__id,
            canceledDate: moment(),
            canceledReason: canceledReason,
            status: DNACPROrderStatus.CANCELED,
        };
        formToDelete = _merge(formToDelete, payload);
        let note = Notes.getCanceledDncprNote(formToDelete);

        updateTags(false);
        saveAdditionalData(newList, note);
    };

    const saveForm = (dnacprForm) => {
        if (dnaCprForm === null) {
            let newList = _.cloneDeep(forms_DNACPR);
            let note = '';
            if (dnacprForm.status === DNACPROrderStatus.AVAITING) {
                let awaiting = {
                    validAddedBy: dnacprForm.createBy,
                    validAddedById: dnacprForm.createById,
                    validAddedSetDate: dnacprForm.createDate,
                    validAddedDate: dnacprForm.detailsAndRationale.validUntil,
                };
                let newItem = _merge(dnacprForm, {
                    awaiting: [awaiting],
                    validUntilDate: dnacprForm.detailsAndRationale.validUntil,
                });
                newList.push(newItem);
                note = Notes.getNewDncprNote(newItem);
            }
            saveAdditionalData(newList, note);
        }
    };

    const updateTags = (add) => {
        let tags = _.cloneDeep(props.patient.tags || []);
        if (add) tags.push(PATIENT_TAGS.DO_NOT_CPR);
        else tags = _.filter(tags, t => t !== PATIENT_TAGS.DO_NOT_CPR);

        API.updatePatientTags(props.patient?.patient?.__id, tags)
            .catch(e => {
                console.error(e);
                dispatch(setSnackbar({type: 'error', message: 'Patient update failed.'}));
            });
    };

    const saveAdditionalData = (list, note = '') => {
        const id = uuidv4() + '';
        const data = {
            'dncpr': list,
        };
        dispatch(updatePatientAdditionalData(props.patient.patient.__id, data));

        dispatch(addNoteForPatient(props.patient.patient.__id, {
            note: note,
            noteType: 'dncpr',
            patientsInWardsRef: [props.patient.__id],
            referenceId: id,
            episodeId: props.patient?.admission?.consultantEpisodeId || null,
        }, props.patient.__id));

        setDnaCprForm(null);
    };

    const renderTableHeader = () => {

        return (
            <TableHead>
                <TableRow className={classes.tableHeader}>
                    <TableCell
                        align="left"
                        className={clsx(classes.borderRadiusLeft, classes.tableCell)}
                    >
                        {t('Expired at')}
                    </TableCell>

                    <TableCell
                        align="left"
                        className={classes.tableCell}
                    >
                        {t('Type')}
                    </TableCell>

                    <TableCell
                        align="left"
                        className={classes.tableCell}
                    >
                        {t('Created by')}
                    </TableCell>

                    <TableCell
                        align="left"
                        className={classes.tableCell}
                    >
                        {t('Created')}
                    </TableCell>

                    <TableCell
                        align="left"
                        className={classes.tableCell}
                    >
                        {t('Cancelled')}
                    </TableCell>

                    <TableCell
                        align="left"
                        className={classes.tableCell}
                    >
                        {t('Cancelled by')}
                    </TableCell>

                    <TableCell
                        align="left"
                        className={classes.tableCell}
                    >
                        {t('Signed')}
                    </TableCell>

                    <TableCell
                        align="left"
                        className={classes.tableCell}
                    >
                        {t('Signed by')}
                    </TableCell>

                    <TableCell
                        align="left"
                        className={clsx(classes.borderRadiusRight, classes.tableCell)}
                    >
                        &nbsp;
                    </TableCell>
                </TableRow>
            </TableHead>
        );
    };

    const getStatus = (status) => {
        // eslint-disable-next-line default-case
        switch (status) {
            case 0:
                return 'Awaiting';
            case 1:
                return 'Active';
            case 2:
                return 'Canceled';
        }
    };

    const renderTableResults = (form, index) => {
        return <>
            <TableRow
                key={index + '_dncpr_row'}
                sx={{'&:last-child td, &:last-child th': {border: 0}, mt: 2}}
                className={classes.tableRow}
            >
                <TableCell
                    align="left"
                    className={clsx(classes.borderRadiusLeft, classes.tableCell)}
                >
                    {form.validUntilDate ? moment(form.validUntilDate)?.format('DD/MM/YYYY') : ''}
                </TableCell>

                <TableCell
                    align="left"
                    className={classes.tableCell}
                >
                    {getStatus(form.status)}
                </TableCell>

                <TableCell
                    align="left"
                    className={classes.tableCell}
                >
                    {form.createBy}
                </TableCell>

                <TableCell
                    align="left"
                    className={classes.tableCell}
                >
                    {form.createDate ? moment(form.createDate)?.format('DD/MM/YYYY HH:mm') : ''}
                </TableCell>

                <TableCell
                    align="left"
                    className={classes.tableCell}
                >
                    {form.canceledDate ? moment(form.canceledDate).format('DD/MM/YYYY HH:mm') : ''}
                </TableCell>

                <TableCell
                    align="left"
                    className={classes.tableCell}
                >
                    {form.canceledBy}
                </TableCell>

                <TableCell
                    align="left"
                    className={classes.tableCell}
                >
                    {form.signedDate ? moment(form.signedDate).format('DD/MM/YYYY HH:mm') : ''}
                </TableCell>

                <TableCell
                    align="left"
                    className={classes.tableCell}
                >
                    {form.signedBy}
                </TableCell>

                <TableCell
                    align="left"
                    className={clsx(classes.borderRadiusRight, classes.tableCell)}
                >
                    <AgyleButton
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            setDnaCprFormIdView(form.id);
                            setDnaCprForm(form);
                            setDnaCprFormView(true);
                        }}
                    >
                        {t('View')}
                    </AgyleButton>

                </TableCell>
            </TableRow>
        </>;
    };

    const getOrderDncpr = () => {
        return _orderBy(forms_DNACPR, pt => pt.createDate.toString(), ['desc']);
    };

    return (
        <div style={{position: 'relative', height: '100%', marginRight: 6, paddingLeft: 10}}>
            {dnaCprFormVisible &&
                <FullScreenForm>
                    {<InlineFormDNACPR
                        patient={props.patient}
                        onSave={saveForm}
                        closeForm={() => {
                            setDnaCprFormVisible(false);
                            dispatch(changePatientContextTab(PATIENT_CONTEXT_TABS_ID.PATIENT));
                        }}
                    />}
                </FullScreenForm>
            }

            {(dnaCprFormIdView != null && dnaCprFormView) &&
                <FullScreenForm>
                    <InlineFormDNACPRView
                        closeForm={() => setDnaCprFormView(false)}
                        onCounterSign={counterSignForm}
                        onExtendDNAR={extendDNARForm}
                        onDelete={deleteForm}
                        form={dnaCprForm}
                    />
                </FullScreenForm>}

            <div className={classes.topButtons}>
                {!haveActiveDNACPR &&
                    <AgyleButton
                        variant="contained"
                        color="primary"
                        onClick={() => setDnaCprFormVisible(true)}
                    >
                        {t('Create new DNACPR Order')}
                    </AgyleButton>
                }
            </div>

            <TableContainer
                style={{marginBottom: '60px', paddingRight: 3, height: '100%'}}
                className={getTableScrollbar()}
            >
                <Table className={classes.table} aria-label="Sepsis pathway">
                    {renderTableHeader(true)}
                    <TableBody>
                        {getOrderDncpr().map((row, index) => renderTableResults(row, index))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
}

export default DNACPRTableView;